/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.giftRewardUpdating = false;
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartRefreshHandler = this.cartRefreshHandler.bind(this);
    this.checkGiftRewardHandler = this.checkGiftReward.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.checkGiftReward();
    });

    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.checkGiftReward();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
    this.checkGiftReward();
  }

  async refreshDrawerAjax() {
    const cartForm = this.querySelector('cart-form');
    if (cartForm && typeof cartForm.refresh === 'function') {
      cartForm.refresh();
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    }
  }

  async checkGiftReward() {
    const reward = window.MacreGiftReward;
    if (!reward || !reward.enabled || !reward.giftVariantId || this.giftRewardUpdating) return;

    this.giftRewardUpdating = true;

    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      let eligibleTotal = 0;
      let giftLineKey = null;

      cart.items.forEach((item) => {
        if (Number(item.variant_id) === Number(reward.giftVariantId)) {
          giftLineKey = item.key;
        } else {
          eligibleTotal += item.final_line_price;
        }
      });

      let changed = false;

      if (eligibleTotal >= Number(reward.threshold) && !giftLineKey) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(reward.giftVariantId),
            quantity: 1
          })
        });

        changed = true;
      }

      if (eligibleTotal < Number(reward.threshold) && giftLineKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftLineKey,
            quantity: 0
          })
        });

        changed = true;
      }

      if (changed) {
        await this.refreshDrawerAjax();
      }
    } catch (error) {
      console.warn('Gift reward error:', error);
    } finally {
      this.giftRewardUpdating = false;
    }
  }
}

window.customElements.define('cart-drawer', CartDrawer);